import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { Feed } from "src/components";
import { CommentSubject } from "src/constants";
import { useSignalR } from "src/hooks";
import { queryKeys, useGetRoleFeed } from "src/http";

interface Props {
  roleGuid: string;
}

const RoleFeed = (props: Props) => {
  const { isLoading, data } = useGetRoleFeed(props.roleGuid);
  const queryClient = useQueryClient();
  const signalR = useSignalR();

  useEffect(() => {
    const handleShouldRefetchComments = (roleGuid: string) => {
      queryClient.invalidateQueries(queryKeys.roles.getRoleFeed(roleGuid));
    };

    signalR.onShouldRefetchComments(handleShouldRefetchComments);
    return () => signalR.offShouldRefetchComments(handleShouldRefetchComments);
  }, [queryClient, signalR]);

  function invalidateRoleFeed() {
    queryClient.invalidateQueries(queryKeys.roles.getRoleFeed(props.roleGuid));
  }

  return (
    <Feed
      subjectType={CommentSubject.Role}
      subjectGuid={props.roleGuid}
      isLoading={isLoading}
      items={data?.feed ?? []}
      onCommentCreated={invalidateRoleFeed}
      onCommentEdited={invalidateRoleFeed}
      onCommentDeleted={invalidateRoleFeed}
    />
  );
};

export { RoleFeed };
